export default "__VITE_ASSET__DHWnd3bY__"